<div class="icon_header_char">
    <app-button-icon [imgUrl]="'assets/svg/plus-icon.svg'" [mat-dialog-close]="false"> </app-button-icon>
</div>
<div class='body'>
    <!-- <h4>{{data.productName}}</h4> -->
    <h3>Edit Certification Date</h3>
    <app-single-calendar [(model)]="date" [relative]="true" [dropDown]="true" label="Certification Start"></app-single-calendar>
    <app-button-primary buttonContent="Save" [mat-dialog-close]="{ date: date }"></app-button-primary>
    <app-button-secondary [isGreen]="false" [isText]="true" buttonText="Cancel" [mat-dialog-close]="false"></app-button-secondary>
</div>